import LaboralRoutes from '@/modules/laboral/laboral.routes';

export default [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    name: 'Mi Negocio',
    icon: 'mdi-view-dashboard-outline',
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/dashboard';
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/RouterViewComponent.vue'),
    redirect: '/dashboard/economic',
    id: 'dashboard-economic',
    meta: {
      allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
      requiresAuth: true,
      toolbar: true,
      tooltip: null,
    },

    children: [
      // {
      //   path: '/dashboard/all',
      //   name: 'Mi Negocio',
      //   icon: 'mdi-view-dashboard',
      //   component: () =>  import(/* webpackChunkName: "dashboard-all" */ './views/DashboardAll.vue'),
      //   meta: {
      //     requiresAuth: true,
      //     toolbar: false,
      //     drawer: false
      //   },
      // },
      {
        name: 'Datos económicos',
        icon: 'mdi-poll',
        path: '/dashboard/economic',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/dashboard';
        },
        component: () =>
          import(/* webpackChunkName: "dashboard-economic" */ './views/EconomicDashboard'),
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          tooltip: null,
          drawer: true,
        },
      },
      ...LaboralRoutes,
      // {
      //   // UserPosts will be rendered inside User's <router-view>
      //   // when /user/:id/posts is matched
      //   name: 'Información laboral',
      //   icon: 'mdi-briefcase',
      //   path: '/dashboard/laboral',
      //   component: () =>
      //     import(/* webpackChunkName: "dashboard-laboral" */ './views/LaboralDashboard'),
      //   meta: {
      //     allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
      //     drawer: true,
      //     tooltip: null,
      //   },
      // },
    ],
  },
];
